import React, { Component } from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Modal, Carousel, message } from 'antd';
import PropTypes from 'prop-types';
import originSize from 'images/origin_size.png';
import suitSize from 'images/suit_size.png';
import './style/index';

const viewerHeight = document.body.clientHeight - 180;

class PrevArrow extends Component {
	static propTypes = {
		onClick: PropTypes.func,
	}

	render () {
		const { onClick } = this.props;
		return (
			<div className={`arrow-prev${!this.props.onClick ? ' arrow-disabled' : ''}`} onClick={onClick}>
				<LeftOutlined title="上一张" />
			</div>
		);
	}
}

class NextArrow extends Component {
	static propTypes = {
		onClick: PropTypes.func,
	}

	render () {
		const { onClick } = this.props;
		return (
			<div className={`arrow-next${!this.props.onClick ? ' arrow-disabled' : ''}`} onClick={onClick}>
				<RightOutlined title="下一张" />
			</div>
		);
	}
}

class SuitSize extends Component {
	static propTypes = {
		showSuitSize: PropTypes.func,
		isOriginSize: PropTypes.bool
	}

	handleChange = () => {
		this.props.showSuitSize();
	}

	render () {
		return (
			<div className="suit-size" onClick={this.handleChange}>
				<img
					className={this.props.isOriginSize ? '' : 'disable-icon'}
					src={suitSize} title='合适尺寸' alt='合适尺寸' />
			</div>
		);
	}
}

class OriginalSize extends Component {
	static propTypes = {
		showOriginalSize: PropTypes.func,
		isOriginSize: PropTypes.bool
	}

	handleChange = () => {
		this.props.showOriginalSize();
	}

	render () {
		return (
			<div className="original-size" onClick={this.handleChange}>
				<img
					className={this.props.isOriginSize ? 'disable-icon' : ''}
					src={originSize} title='原始尺寸' alt='原始尺寸' />
			</div>
		);
	}
}

class ImgSliderModal extends Component {
	static propTypes = {
		className: PropTypes.string,
		style: PropTypes.object,
		urls: PropTypes.array,
		width: PropTypes.string,
		height: PropTypes.number,
		arrows: PropTypes.bool,
		dots: PropTypes.bool,
		infinite: PropTypes.bool,
	}

	static defaultProps = {
		urls: [],
		width: 'auto',
		height: viewerHeight,
		arrows: true,
		dots: false,
		infinite: false,
	}

	constructor (props) {
		super(props);
		this.state = {
			showModal: false,
			isOriginSize: false
		};
	}

	// getUrls = () => {
	// 	const { urls = [] } = this.props;
	// 	if (urls.length === 1) {
	// 		message.info('只有一张图片');
	// 	}
	// }

	// showModal = () => {
	// 	this.setState({
	// 		showModal: true,
	// 	});
	// 	this.getUrls();
	// }

	// hideModal = () => {
	// 	this.setState({
	// 		showModal: false,
	// 	});
	// }

	showSuitSize = () => {
		this.setState({
			isOriginSize: false
		});
	}

	showOriginalSize = () => {
		this.setState({
			isOriginSize: true
		});
	}

	render () {
		const { className, style, urls = [], width, height, dots, visible } = this.props;
		const { showModal, isOriginSize } = this.state;
		const simpleMode = urls && urls.length && typeof urls[0] === 'string';
		return <div className={`imageSlider${className ? ` ${className}` : ''}`} style={style}>
			{urls.length && visible ? <Modal className="imageSlider-modal" width={`${width}px`} visible={visible} maskClosable={true} footer={null} onCancel={this.props.onClose} zIndex={2000}>
				<Carousel
					{...this.props}
					className={`imageSlider-carousel${!dots ? ' no-padding' : ''}`}
					style={null}
					prevArrow={<PrevArrow />}
					nextArrow={<NextArrow />}
				>
					{urls.map((v, i) => (<div className={isOriginSize ? 'imageWrap originSizeWrap' : 'imageWrap'} key={i}>
						<img
							alt={simpleMode ? '' : v.alt}
							className={isOriginSize ? 'originSize-image' : ''}
							style={{ maxHeight: `${height}px`, maxWidth: `${width}px` }}
							src={simpleMode ? v : v.src}
						/>
						{!simpleMode && 'desc' in v && v.desc !== '' ? <div>{v.desc}</div> : null}
					</div>))}
				</Carousel>
				<SuitSize isOriginSize={isOriginSize} showSuitSize={this.showSuitSize} />
				<OriginalSize isOriginSize={isOriginSize} showOriginalSize={this.showOriginalSize} />
			</Modal> : null}
		</div>;
	}
}

export default ImgSliderModal; // eslint-disable-line
